import { LinkButton } from '@moniebook-web/components/atoms/button';
import { Body, Title } from '@moniebook-web/components/atoms/typography';
import { Logo } from '@moniebook-web/components/molecules/logo';

import { config } from '@/config';

export function GhostSessionExpired() {
    return (
        <div className='flex h-full px-16'>
            <div className='mx-auto flex max-w-auth-container'>
                <div className='py-20'>
                    <Logo />
                </div>
                <div className='grow'>
                    <section className='flex h-full flex-col items-center justify-center'>
                        <div className='flex w-full flex-col items-center md:w-480!'>
                            <div className='mb-16 flex w-120 flex-col items-center'>
                                <img
                                    src='/illustrations/hour-glass-soon.svg'
                                    alt='Session timed out'
                                    loading='lazy'
                                />
                            </div>
                            <div className='w-full py-8 text-center'>
                                <Title className='font-general-sans font-semibold text-content-heading-default'>
                                    Access session expired
                                </Title>
                            </div>
                            <div className='w-full py-16 text-center'>
                                <Body className='text-content-subtext-alternative'>
                                    Your access session has expired, Please
                                    request a new session to regain access
                                </Body>
                            </div>
                            <div className='w-full px-0 py-20 md:px-24'>
                                <LinkButton
                                    label='Request new session'
                                    size='small'
                                    className='w-full'
                                    target='_blank'
                                    to={config.MONIEBOOK_BACKOFFICE_URL}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
